// extracted by mini-css-extract-plugin
module.exports = {"container":"gallery3_container__2Sycz","containerLeft":"gallery3_containerLeft__2gQcG","imgLeft":"gallery3_imgLeft__1Zceh","imgRight":"gallery3_imgRight__3AIJN"};